import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OpenIOChatService {

  private apiUrl = 'https://api.openai.com/v1/chat/completions';
  private apiKey = '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';

  constructor(private http: HttpClient) {
  }

  // tslint:disable-next-line:ban-types
  sendMessage(text, image): Observable<any> {
    const payload = {
      // model: 'gpt-4',
      model: 'gpt-3.5-turbo',
      messages : [
        {role: 'user', content: text},
        {role: 'user', content: image}
    ]
    };

    const headers = {
      Authorization: `Bearer ${this.apiKey}`
    };
    return this.http.post<any>(this.apiUrl, payload, { headers }).pipe(
      map(response => response.choices[0].message.content) // Yanıtın sadece 'choices' kısmını döndür
    );
  }
}
